<template>
  <EBody :style="body">
    <ESection
      :style="{
        padding: '20px',
        backgroundColor: '#fff',
        width: '100%',
        textAlign: getAlignment(item.alignment),
      }"
    >
      <EButton
        :href="item.url"
        :style="{
          backgroundColor: item.backgroundColor,
          padding: '5px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          lineHeight: '22px',
          textAlign: 'center',
          color: item.foregroundColor,
          width: item.fullWidth ? 'calc(100% - 32px)' : 'auto',
        }"
      >
        {{ item.text }}
      </EButton>
    </ESection>
  </EBody>
</template>

<script setup lang="ts">
import { EBody, EButton, ESection } from "vue-email";

import { body } from "@/app/flows/emailTemplates/utils/defaultStyles";
import { ButtonItem, ItemAlignment } from "@/@types/flows/emailTemplates/items";

defineProps<{ item: ButtonItem }>();

const getAlignment = (alignment: ItemAlignment) => {
  if (alignment === ItemAlignment.Center) return "center";
  if (alignment === ItemAlignment.Right) return "right";
  return "left";
};

// function luminance(r: number, g: number, b: number) {
//   const a = [r, g, b].map(function (v) {
//     v /= 255;
//     return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
//   });
//   return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
// }

// const getTextColor = (hexColor: string) => {
//   const rgb = hexColor.match(/\w\w/g)?.map((x) => parseInt(x, 16));

//   if (!rgb) return "#000000";

//   // Calcula la luminancia
//   const lum = luminance(rgb[0], rgb[1], rgb[2]);
//   // Devuelve negro (#000000) o blanco (#FFFFFF) dependiendo de la luminancia
//   return lum > 0.5 ? "#000000" : "#FFFFFF";
// };
</script>

<style scoped lang="sass"></style>
